module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-162.05049c53.svg";